export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új cég',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            }, {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            }],
        rowActions: [
            {
                btn_text: '<i class="fas fa-copy"></i>',
                title: 'Másolás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'copyRow'
            }, 
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            }, 
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            }],
        headerFields: [
            {
                name: "id",
                label: "Azonosító",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "name",
                label: "Cégnév",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
                formType: 'text',
                formSize: 4,
                formVisible: true,
                formRequired: true
            },
            {
                name: "taxNumber",
                label: "Adószám",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formType: 'text',
                formSize: 4,
                formVisible: true,
                formRequired: true
            },
            {
                name: "registrationNumber",
                label: "Cégjegyzékszám",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formType: 'text',
                formSize: 4,
                formVisible: true,
                formRequired: true
            },
            {
                name: "baseAddressId",
                label: "baseAddressId",
                visibility: false,
                formType: 'number',
            },
            {
                name: "createdBy",
                label: "createdBy",
                visibility: false,
                formType: 'text',
            },
            {
                name: "createdOn",
                label: "createdOn",
                visibility: false,
                formType: 'date',
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                visibility: false,
                formType: 'text',
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                visibility: false,
                formType: 'date',
            },
            {
                name: "deleted",
                label: "deleted",
                visibility: false,
            },
            {
                name: "ownerName",
                label: "Tulajdonos neve",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
                formSize: 3,
                formVisible: true
            },
            {
                name: "ownerPhone",
                label: "Tulajdonos telefonszáma",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'tel',
                formSize: 3,
                formVisible: true
            },
            {
                name: "ownerEmail",
                label: "Tulajdonos e-mail címe",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'email',
                formSize: 3,
                formVisible: true
            },
            {
                name: "nyilvantartasiSzam",
                label: "Nyilvántartási szám",
                visibility: false,
                formType: 'text',
                formSize: 3,
                formVisible: true
            },
            {
                name: "baseAddress",
                visibility: false,
                formVisible: false
            },
            {
                name: "address",
                visibility: false,
                formType: 'address',
                formVisible: true
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
